<template>
  <div>
    <a class="backBtn" :href="`/#/mission/${missionId}/actividad`">
      <img src="/img/back-icon.png" />
    </a>
    <div class="screen-container-book" :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`">
      <iframe :src="`https://www.mdt.mx/KrismarApps/index.php/recurso/cargarApp/${actividadId}/primaria`" frameborder="0"  width="835px" height="432px" style="border: none" id="actividadesIframe"></iframe>
    </div>
  </div>
</template>
<script>
import Auth from '../services/Auth';
import NProgress from 'nprogress';
import Button from '../components/Button.vue';

export default {
  components: { Button },
  name: 'Actividad',
  created() {
    this.init();
    NProgress.done();
  },
  computed: {
    missionId () {
      return parseInt(this.$route.params.missionId);
    },
    actividadId () {
      return parseInt(this.$route.params.actividadId);
    }
  },
  methods: {
    init() {
      console.log(this.actividadId)
    },
    logout() {
      Auth.logout();
    },
  },
}
</script>
<style lang="scss">
  #actividadesIframe {
    width: 835px;
    height: 432px;
  }
  #app #book .i_ingresar {
    color: blue!important
  }
  .backBtn {
    position: absolute;
    right: 55px;
    width: 55px;
    height: auto;
    z-index: 9999;
    img {
      width: 35px;
      height: 35px;
      margin: 7.5px;
    }
  }
</style>